import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const FARM_QUERY = gql(`
  query Farm($farmId: ID!, $filter: SceneFilter!) {
    farm(id: $farmId) {
      id
      name
      allScenes(filter: $filter) {
        id
        spacecraft
        capturedOn
        cloudCoverage
        preview(maxHeight: 150, maxWidth: 345)
      }
    }
  }
`);

const handleFetchMore = (fetchMore: any, props: Props, scenes: Scene[]) => {
  if (scenes.length) {
    const lastCapturedOn = scenes[scenes.length - 1].capturedOn;
    fetchMore({
      variables: {
        farmId: props.farmId,
        filter: {
          ...props.sceneFilter,
          lastCapturedOn
        }
      },
      updateQuery: (prev: any, { fetchMoreResult }: any) => {
        return Object.assign({}, prev, {
          farm: {
            ...prev.farm,
            allScenes: [
              ...prev.farm.allScenes,
              ...fetchMoreResult.farm.allScenes
            ]
          }
        });
      }
    });
  }
};

interface SceneFilter {
  capturedSince?: string;
  capturedUntil?: string;
  criticalMonths?: number[];
  spacecrafts?: string[];
  limit?: number;
}

interface Props {
  farmId: string;
  sceneFilter: SceneFilter;
  children: (farm: Farm | null, scenes: Scene[] | null, loading: boolean, fetchMore: () => void) => React.ReactNode;
}

const FarmScenesProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery
    query={FARM_QUERY}
    variables={{farmId: props.farmId, filter: props.sceneFilter}}
    notifyOnNetworkStatusChange={true}
  >
    {({ data, loading, fetchMore }) =>
      data && data.farm ?
        props.children(
          data.farm,
          data.farm.allScenes,
          loading,
          () => handleFetchMore(fetchMore, props, data.farm.allScenes)
        ) :
        props.children(
          null,
          null,
          loading,
          () => handleFetchMore(fetchMore, props, [])
        )}
  </AuthorizedQuery>
);

export default FarmScenesProvider;


// WEBPACK FOOTER //
// ./src/providers/FarmScenesProvider.tsx